import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=476fb6ac"
import script from "./topmenu.vue?vue&type=script&lang=js"
export * from "./topmenu.vue?vue&type=script&lang=js"
import style0 from "./topmenu.vue?vue&type=style&index=0&id=476fb6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports